<template>
  <v-layout row wrap>
    <v-container>
      <v-btn v-if="user && ((topic.userRef && topic.userRef.id === user.uid) || isCommunityOwner)"
             dark fab right color="teal" slot="activator"
             @click="editFlag = true" style="bottom: 30px; right:10px; position: fixed; z-index: 1">
        <v-icon>edit</v-icon>
      </v-btn>

      <v-layout class="mb-2" style="width: 100%">
        <v-flex>
          <v-item v-if="topic.isPublic">
            <v-chip class="subheading font-weight-medium"
                    color="teal lighten-3" text-color="white"
                    @click="gotoCategory('public')">Public</v-chip>
          </v-item>
          <template v-for="(category, index) in categories">
            <v-item v-if="topic.categoryRef && topic.categoryRef.id !== 'public'" :key="index">
              <v-chip v-if="topic.categoryRef && topic.categoryRef.id === category.id"
                      class="subheading font-weight-medium" :color="category.color + ' lighten-3'"
                      @click="gotoCategory(category.id)" text-color="white">
                {{ category.name }}
              </v-chip>
            </v-item>
          </template>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm3 class="mb-3">
          <TopicDetailPanel :topic="topic" :isReadMore="false"></TopicDetailPanel>
        </v-flex>

        <v-flex xs12 sm6 pa-2>
          <tiptap-editor :content="topic.about" :editable="false"></tiptap-editor>
        </v-flex>

        <v-flex xs12 sm3>
          <TopicCommentPanel :topic="topic" :isOpen="true"></TopicCommentPanel>
        </v-flex>
      </v-layout>

      <template v-if="topic.relatedTopics && topic.relatedTopics.length">
        <h3>Related Topics</h3>
        <v-layout row wrap>
          <template v-for="(relatedTopic, i) in topic.relatedTopics">
            <TopicCard :key="i" :topic="relatedTopic"></TopicCard>
          </template>
        </v-layout>
      </template>

      <v-dialog v-model="editFlag" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="teal">
            <v-btn icon dark @click="editFlag = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Rich Text Editor</v-toolbar-title>
          </v-toolbar>
          <v-container>
            <v-layout wrap>
              <v-flex xs12 sm6 offset-sm3 class="mt-3">
                <tiptap-editor :content="topic.about" @onBlur="editContent"></tiptap-editor>
              </v-flex>
              <v-flex xs12 text-xs-center>
                <v-btn :loading="isTopicAboutSaving" :disabled="isTopicAboutSaving"
                       color="teal white--text" @click="saveAbout()">
                  save
                  <span slot="loader">Loading...</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>

    </v-container>
  </v-layout>
</template>

<script>
import firebase from 'firebase';
import TiptapEditor from '@/components/TiptapEditor.vue';
import TopicCard from '@/components//topic/TopicCard.vue';
import TopicCommentPanel from '@/components/topic/TopicCommentPanel.vue';
import TopicDetailPanel from '@/components/topic/TopicDetailPanel.vue';
import html2canvas from 'html2canvas';

export default {
  name: 'TopicSpace',
  components: {
    TopicDetailPanel,
    TopicCommentPanel,
    TopicCard,
    TiptapEditor,
  },
  props: {
    user: Object,
    communityId: String,
    isCommunityJoined: Boolean,
    isCommunityOwner: Boolean,
    categories: Array,
  },
  data() {
    return {
      title: 'Community Topic',
      text: 'topic',
      topicId: '',
      panel: [true],
      topic: {},
      editFlag: false,
      isTopicAboutSaving: false,
    };
  },
  head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function () {
      return {
        inner: this.topic.title,
        complement: this.communityName,
      };
    },
    meta: function () {
      return [
        { property: 'og:title', content: this.topic.title },
      ];
    },
  },
  created() {
    // this.$on('okHead', () => {
    // });
    this.topicId = this.$route.params.topicId;
    this.getTopic();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.topicId !== from.params.topicId) {
      this.topicId = to.params.topicId;
      this.getTopic();
    }

    next();
  },
  computed: {
    communityName() {
      return this.$store.state.communityName;
    },
  },
  methods: {
    gotoCategory(categoryId) {
      this.$router.push(`/c/${this.communityId}/category/${categoryId}`);
    },
    gotoTopic(topicId) {
      this.$router.push(`/c/${this.communityId}/topic/${topicId}`);
    },
    getTopic() {
      this.topic = {};
      const topicRef = firebase.firestore().doc(`communities/${this.communityId}/topics/${this.topicId}`);

      topicRef.get().then((topicDoc) => {
        if (topicDoc.exists) {
          this.topic = {
            id: topicDoc.id,
            communityId: this.communityId,
            title: topicDoc.data().title,
            about: topicDoc.data().about,
            color: topicDoc.data().color,
            isPublic: topicDoc.data().isPublic,
            isPinned: topicDoc.data().isPinned,
            userRef: topicDoc.data().userRef,
            categoryRef: topicDoc.data().categoryRef,
            likes: topicDoc.data().likes,
            isLiked: topicDoc.data().likes
              ? topicDoc.data().likes.filter(like => like.uid === this.user.uid).length : false,
            shares: topicDoc.data().shares,
            commentNum: topicDoc.data().commentNum,
            relatedTopicRefs: topicDoc.data().relatedTopicRefs,
            relatedTopics: [],
            createdAt: topicDoc.data().createdAt,
          };
          
          if (this.topic.relatedTopicRefs && this.topic.relatedTopicRefs.length) {
            this.getRelatedTopics();
          }
          
          if (this.$route.query.thumbnail) {
            this.createThumbnail();
          }
          
          // update header tag
          this.$emit('updateHead');
        }
      }).catch((error) => {
        console.error(error);
      });
    },
    getRelatedTopics() {
      this.topic.relatedTopicRefs.forEach((relatedTopicRef) => {
        relatedTopicRef.get().then((relatedTopicDoc) => {
          if (relatedTopicDoc.exists) {
            this.topic.relatedTopics.push({
              id: relatedTopicDoc.id,
              communityId: this.communityId,
              title: relatedTopicDoc.data().title,
              about: relatedTopicDoc.data().about,
              color: relatedTopicDoc.data().color,
              isPublic: relatedTopicDoc.data().isPublic,
              isPinned: relatedTopicDoc.data().isPinned,
              userRef: relatedTopicDoc.data().userRef,
              likes: relatedTopicDoc.data().likes,
              isLiked: relatedTopicDoc.data().likes
                ? relatedTopicDoc.data().likes.filter(like => like.uid === this.user.uid).length : false,
              shares: relatedTopicDoc.data().shares,
              commentNum: relatedTopicDoc.data().commentNum,
              createdAt: relatedTopicDoc.data().createdAt,
            });
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    },
    createThumbnail() {
      html2canvas(document.getElementById('topic-header'), { scale: 2 }).then((canvas) => {
        const base64 = canvas.toDataURL('image/png');

        const bin = atob(base64.replace(/^.*,/, ''));
        const buffer = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++) {
          buffer[i] = bin.charCodeAt(i);
        }
        // Blobを作成
        const blob = new Blob([buffer.buffer], {
          type: 'image/png',
        });
        const storageRef = firebase.storage().ref();
        const thumbnailRef = storageRef.child(`images/communities/${this.communityId}/topics/thumbnail-${this.topicId}.png`);
        thumbnailRef.put(blob).then((snapshot) => {
          console.log('Uploaded a topic thumbnail!');
          snapshot.ref.getDownloadURL().then(url => console.log(url));
        });
      });
    },
    editContent(content) {
      this.editAbout = content;
    },
    saveAbout() {
      this.isTopicAboutSaving = true;
      const topicRef = firebase.firestore().doc(`communities/${this.communityId}/topics/${this.topicId}`);

      topicRef.update({
        about: this.editAbout,
      }).then(() => {
        this.isTopicAboutSaving = false;
        this.topic.about = this.editAbout;
        this.editFlag = false;
      }).catch((error) => {
        console.error(error);
      });
    },
  },
};
</script>

<style lang='scss'>
  @import "../../../assets/sass/main";
  tt, code, kbd, samp {
    font-size: 100%;
    background: transparent;
    color: white;
  }
  code::after, kbd::after, code::before, kbd::before {
    content: none;
  }
</style>

<style scoped>
  .v-list__tile__avatar {
    min-width: 36px!important;
  }
  .v-avatar {
    width: 30px!important;
    height: 30px!important;
  }
  .v-card__text {
    padding: 10px;
  }
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .75;
    position: absolute;
    width: 100%;
    z-index: 100;
  }
  .v-note-wrapper{
    z-index: 0;
  }

  /*comments*/
  .au-chat__content {
    padding: 0 10px;
    overflow-y: auto;
    position: relative;
    font-size: 12px;
   }
  .mess-wrap {
    padding-bottom: 12px;
  }
  .recei-mess-wrap {
    text-align: center;
  }
  .mess-time {
    font-size: 14px;
    color: #999;
  }
  .recei-mess__inner {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    margin-top: 6px;
  }
  .recei-mess__inner {
    -webkit-align-self: flex-end;
    -ms-flex-item-align: end;
    align-self: flex-end;
    justify-self: flex-start;
    margin-right: 10px;
  }
  .recei-mess-list {
    margin-left: 12px;
  }
  .recei-mess {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
    padding: 8px 16px;
    max-width: 100%;
    margin-bottom: 2px;
    text-align: left;
    white-space:pre-wrap;
    white-space: -moz-pre-wrap;
    word-wrap:break-word;
    overflow-wrap: break-word;
  }
</style>
